import React, { useState } from 'react';

import Alert from '../Alert';

import Input from '../Input';
import Button from '../Button';

import { gtmAttributesCopyToken } from '../../utils/gtmVariables';

import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';

interface Props {
  buttonText: string;
  inputValue: string;
  id: string;
}

const InputCopy = ({ buttonText, inputValue, id }: Props) => {
  const [show, setShow] = useState(false);
  const gtmEventsTracker = useGTMEventsTracker();

  function copyTextInput() {
    gtmEventsTracker(gtmAttributesCopyToken);
    const val = (document.getElementById('input-copy') as HTMLInputElement).value;
    navigator.clipboard?.writeText(val).then(function () {
      setShow(true);
      setTimeout(() => {
        setShow(false);
      }, 5000);
    });
  }

  return (
    <div id="mp__input" className="wrapper-input-copy relative">
      <Input
        type="text"
        name="input-copy"
        label="Token de ativação"
        value={inputValue}
        className="input-copy w-[55%] pr-9 bg-transparent"
        disabled={true}
        readOnly={true}
        id="input-copy"
      />
      <Button
        type="button"
        text={buttonText}
        classNames="button-copy absolute right-0 top-[27.4px] w-[48.5%] h-[48.25px] bg-[#00a5a5] text-neutral-lightest leading-[19px] font-normal hover:bg-[#00a5a5] focus:bg-[#00a5a5] max-[320px]:text-xs"
        onClick={() => copyTextInput()}
      />
      <div className="absolute top-[7.688rem] right-6 w-[23.625rem] max-[576px]:left-[2.5%] max-[576px]:w-[95%]">
        <Alert
          show={show}
          variant="success"
          onClose={() => setShow(false)}
          dismissible
          closeVariant="white"
          id={id}
        >
          <p>Token copiado!</p>
        </Alert>
      </div>
    </div>
  );
};

export default InputCopy;
